'use client'

import { usePathname } from 'next/navigation'
import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { type ThemeProviderProps } from 'next-themes'

// Routes where the user can switch themes (dashboards, portals)
const THEME_UNLOCKED_PREFIXES = [
  '/dashboard',
  '/command-center',
  '/admin',
  '/instructor',
  '/expert',
  '/project-manager',
]

// Routes forced to light mode (premium editorial pages)
const FORCE_LIGHT_PREFIXES = [
  '/masterclass',
]

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const pathname = usePathname()

  const isForceLight = FORCE_LIGHT_PREFIXES.some(prefix =>
    pathname.startsWith(prefix)
  )

  // Dashboard/portal routes allow theme switching; landing pages stay dark
  const isUnlocked = THEME_UNLOCKED_PREFIXES.some(prefix =>
    pathname.startsWith(prefix)
  )

  // Masterclass pages are always light; unlocked routes allow switching; everything else is dark
  const forcedTheme = isForceLight ? 'light' : isUnlocked ? undefined : 'dark'

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      forcedTheme={forcedTheme}
      enableSystem={false}
      disableTransitionOnChange={false}
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}
